/**
 * Resolve the AudioContext constructor, falling back to the webkit-prefixed
 * one (older Safari / iOS WebKit). The standard lib type doesn't declare
 * `webkitAudioContext`, so the single cast that needs is isolated here instead
 * of being repeated at every call site that creates an AudioContext.
 */
export function getAudioContextCtor(): typeof AudioContext {
  return (
    window.AudioContext ??
    (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext
  );
}
